import { createElement } from 'react';
import { createSvg } from './createSvg.js';
import '@vebox/etui-system';
import '@vebox/etui-system-elements';

const AuditTrailGlyph = /*#__PURE__*/createElement("g", {
  id: "audit_trail"
}, /*#__PURE__*/createElement("path", {
  d: "M33.9,69.4c-3.6,0-4.9-3.5-6.1-6.7c-0.3-0.8-0.6-1.6-0.9-2.4l0-0.1c-0.5-1.5-1.8-3.4-3.3-5.5c-2.4-3.5-5.1-7.4-5.1-11 c0-4.6,6.8-10.4,11.1-10.6c2.5-0.1,6,0.8,8.1,3.3c1.6,1.8,2.2,4.1,1.8,6.8c-0.1,0.8-0.4,1.6-0.8,2.3c-1,2.3-2,4.8,1.3,9.9 c1.7,2.6,2.1,5.7,0.9,8.6c-1,2.6-3.2,4.7-5.4,5.3C34.9,69.3,34.4,69.4,33.9,69.4z M29.7,59.2c0.3,0.8,0.6,1.7,0.9,2.4 c1.5,4.1,2.1,5.1,4.2,4.6c1.1-0.3,2.5-1.5,3.3-3.4c0.5-1.1,1-3.4-0.6-5.8c-4.2-6.4-2.6-10.2-1.6-12.7c0.3-0.6,0.5-1.2,0.6-1.7 c0.3-1.7-0.1-3.2-1.1-4.3c-1.6-1.8-4.3-2.3-5.7-2.3l0,0c-2.8,0.1-8.2,4.8-8.2,7.6c0,2.7,2.4,6.2,4.6,9.3 C27.6,55.3,29,57.4,29.7,59.2z"
}), /*#__PURE__*/createElement("g", null, /*#__PURE__*/createElement("ellipse", {
  cx: "33.4",
  cy: "26.7",
  rx: "3",
  ry: "4"
})), /*#__PURE__*/createElement("g", null, /*#__PURE__*/createElement("ellipse", {
  cx: "26.6",
  cy: "27.5",
  rx: "2",
  ry: "2.6"
})), /*#__PURE__*/createElement("g", null, /*#__PURE__*/createElement("ellipse", {
  cx: "22.3",
  cy: "30.3",
  rx: "1.5",
  ry: "2"
})), /*#__PURE__*/createElement("g", null, /*#__PURE__*/createElement("ellipse", {
  cx: "18.5",
  cy: "33.8",
  rx: "1.5",
  ry: "2"
})), /*#__PURE__*/createElement("g", null, /*#__PURE__*/createElement("ellipse", {
  cx: "16.2",
  cy: "38",
  rx: "1.1",
  ry: "1.4"
})), /*#__PURE__*/createElement("path", {
  d: "M51.7,61.5c-0.4,0-0.8,0-1.3-0.1c-2.2-0.4-4.5-2.4-5.6-5c-1.3-2.9-1.1-5.9,0.5-8.6c3.1-5.2,1.9-7.7,0.8-9.9 c-0.4-0.8-0.7-1.5-0.9-2.3c-0.6-2.6-0.1-5,1.4-6.9c2-2.5,5.4-3.7,7.9-3.7l0,0c0,0,0,0,0,0c4.3,0,11.4,5.4,11.6,10 c0.2,3.6-2.3,7.7-4.6,11.3c-1.3,2.1-2.6,4.2-3,5.7l0,0.1c-0.3,0.8-0.5,1.6-0.8,2.4C56.7,57.8,55.5,61.5,51.7,61.5z M54.5,28 c-1.4,0-4.1,0.7-5.6,2.6c-0.9,1.2-1.2,2.6-0.8,4.3c0.1,0.5,0.4,1,0.7,1.6c1.2,2.4,3,6.1-0.9,12.8c-1.5,2.5-0.8,4.7-0.3,5.9 c0.9,1.9,2.4,3.1,3.5,3.3c2.1,0.4,2.6-0.6,3.9-4.8c0.2-0.8,0.5-1.6,0.8-2.5c0.5-1.9,1.9-4.1,3.3-6.4c2-3.2,4.3-6.9,4.1-9.6 C62.9,32.4,57.2,28,54.5,28C54.5,28,54.5,28,54.5,28L54.5,28z"
}), /*#__PURE__*/createElement("g", null, /*#__PURE__*/createElement("ellipse", {
  cx: "50.6",
  cy: "18.6",
  rx: "3",
  ry: "4"
})), /*#__PURE__*/createElement("g", null, /*#__PURE__*/createElement("ellipse", {
  cx: "57.4",
  cy: "19.5",
  rx: "2",
  ry: "2.6"
})), /*#__PURE__*/createElement("g", null, /*#__PURE__*/createElement("ellipse", {
  cx: "61.7",
  cy: "22.2",
  rx: "1.5",
  ry: "2"
})), /*#__PURE__*/createElement("g", null, /*#__PURE__*/createElement("ellipse", {
  cx: "65.5",
  cy: "25.7",
  rx: "1.5",
  ry: "2"
})), /*#__PURE__*/createElement("g", null, /*#__PURE__*/createElement("ellipse", {
  cx: "67.8",
  cy: "29.9",
  rx: "1.1",
  ry: "1.4"
})));
const AuditTrail = createSvg({
  name: 'audit_trail',
  path: AuditTrailGlyph
});

export default AuditTrail;
export { AuditTrailGlyph };
